<template>
  <v-container>
    <TaxRollAdjustmentsCriteria
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="handleLoadCRUDList"
    />
    <template>
   <CRUDList
      ref="crudList"
      :canAdd="isAjustmentAccessible"
      :addDisabledTooltip="isAjustmentAccessible ? '' : adjustmentCreateForbiddenMsg"
      :canEdit="true"
      :canSave="false"
      :showSelect="true"
      :enableFixedHeaders="true"
      :useSelectedItemsStore="true"
      :displayTopPagination="false"
      :headers="headers"
      :baseCrudKey="baseCrudKey"
      :dialogHeaderName="dialogHeaderName"
      :createNewItem="newItemDialog"
      :defaultSortBy="defaultSortBy"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-1 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='300'
      @loadCRUDList="handleLoadCRUDList"
      @activateItem="handleAddOrEdit"
      @crudDialogClose="crudDialogClose"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
    >
    <template v-slot:[`editedItem`]="{}">
        <TaxRollAdjustmentsDialogForm :baseCrudKey="baseCrudKey" ref="adjustmentDialog"
        :upsrtTransaction="upsrtTransaction"
        :isSaving="isSaving"
        :handleLoadCRUDList="handleLoadCRUDList" />
      </template>
      <template v-slot:[`additionalActions`]="{}">
        <AuditDialog
          v-if="getActiveTransID"
          :identifier="getActiveTransID"
          activatorCaption="Audit History"
          activatorCaptionStyle="input-text-size" />
      </template>
      <template v-slot:[`additionalActionsAfterSave`]="{}">
        <v-btn class="input-text-size" text color="blue darken-1" v-if="enableSaveBtn"
        :disabled="isSaving" @click="upsrtTransaction()">Save</v-btn>
      </template>
    </CRUDList>
    </template>
    <TaxRollAdjustmentsFooter
      :createWorkFile="createWorkFile"
      :postSelectedRecords="postSelectedRecords"
      :createReversingEntry="createReversingEntry"
     />
     <CommonPopUp v-model="showAdjPopUp" v-if="showAdjPopUp"
    :enableFlashTypeMsg="false" @onEnter="openConfirmPopUpAdj('continue')">
      <template v-slot:customsLabelOrInfo>
        <span class="elevation-1" v-if="(allMessageText || []).length">
          <h4 class="ml-5">{{errorMsgTaxYearTaxIdFunc}}</h4>
          <span
          v-for="(textName) in allMessageText"
          :key="textName.txtName"><br/>
          <p style="white-space: pre;">
            <v-icon :class="handleCircleClass(textName.txtName)">
              {{ icons.mdiCircleSlice8 }}
            </v-icon> {{ textName.txtMsg }}
          </p>
        </span>
      </span>
      </template>
      <template v-slot:[`customsButtonsForPopUp`]="{}">
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="openConfirmPopUpAdj('continue')"
        :disabled="disablePostAdjBtn">Post Adjustments</v-btn>
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="openConfirmPopUpAdj('Cancel')">Cancel</v-btn>
      </template>
    </CommonPopUp>

    <!-- Error Dialog with centered content and single button -->
    <CommonPopUp v-model="showErrorDialog" v-if="showErrorDialog"
      :enableFlashTypeMsg="false" :custumWidth="400">
      <template v-slot:customsLabelOrInfo>
        <div class="error-dialog-content">
          <h3 class="error-title">Posting Not Allowed</h3>
          <div class="error-message" v-if="(allMessageText || []).length">
            <p v-for="(textName) in allMessageText.filter((t) => t.txtName === 'defaultText')"
               :key="textName.txtName"
               class="text-center">
              {{ textName.txtMsg }}
            </p>
          </div>
        </div>
      </template>
      <template v-slot:[`customsButtonsForPopUp`]="{}">
        <div class="single-button-container">
          <v-btn class="input-text-size" text color="blue darken-1"
          @click="closeErrorDialog">OK</v-btn>
        </div>
      </template>
    </CommonPopUp>
  </v-container>
</template>

<script>
import {
  mdiCircleSlice8,
} from '@mdi/js';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import '../../../assets/style.css';
import { toIsoDate, toShortDate } from '../../../util/shared/tmc-global';
import {
  amountFormat, amountToNumber, defaultGridLoading, manageGridLoading,
} from '../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../util/workstation-util';
import { adjustmentCreateForbiddenMsg } from '../../../store/auth/token';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import CommonPopUp from '../common-utils/CommonPopUp.vue';
import { makeCriteriaStateNullIfEmptyString } from '../common-utils/CommonTaxFunctionalities';
import TaxRollAdjustmentsDialogForm from '../common-utils/CommonTaxRollAdjustmentsDialogForm.vue';
import { POST_LOAD_COMP_TIMER } from '../common-utils/constants';
import { parseLocalDate } from '../common-utils/tax-common.util';
import TaxRollAdjustmentsCriteria from './TaxRollAdjustmentsCriteria.vue';
import TaxRollAdjustmentsFooter from './TaxRollAdjustmentsFooter.vue';
import { TaxRollAdjustmentsListHeader } from './TaxRollAdjustmentsUtils/TaxRollAdjustments.Utils';
import AuditDialog from '../../common/audit/AuditDialog.vue';

export default {
  name: 'TaxRollAdjustmentsList',
  components: {
    TaxRollAdjustmentsCriteria,
    TaxRollAdjustmentsFooter,
    CRUDList,
    TaxRollAdjustmentsDialogForm,
    CommonPopUp,
    AuditDialog,
  },
  data() {
    return {
      baseCrudKey: 'taxRollAdjustmentsList',
      headers: TaxRollAdjustmentsListHeader,
      dialogHeaderName: 'Tax Roll Adjustment',
      gridLoading: defaultGridLoading(),
      canSave: true,
      isItFirstCallOrNot: false,
      disabledPosted: true,
      showAdjPopUp: false,
      disablePostAdjBtn: false,
      enableSaveBtn: true,
      // Guards against a double-click on Save, or Enter immediately followed by a click, firing
      // upsrtTransaction() twice before the first request returns - the backend collapses that
      // to one adjustment, but used to apply it to the tax record and tax roll summary twice
      // (Cherokee, Asana 2026-09-29).
      isSaving: false,
      errorMsgTaxYearTaxId: [],
      allMessageText: [],
      adjSelectedIds: [],
      icons: {
        mdiCircleSlice8,
      },
      showErrorDialog: false,
      activeTransItem: undefined,
      adjustmentCreateForbiddenMsg,
    };
  },
  created() {
    this.initCriteria();
    // this.loadLists();
    this.wkstID = getWorkstationNumber();
  },
  mounted() {
    // if (this.latestTaxYear) {
    //   this.isItFirstCallOrNot = true;
    //   this.handleLoadCRUDList();
    // }
    if (this.defaultTaxYearFromTaxSetting) {
      this.isItFirstCallOrNot = true;
      this.handleLoadCRUDList();
    }
    this.setSelectedItemsOfAllPages([this.baseCrudKey, []]);
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'items', 'isValidFormProp', 'selectedItemsOfAllPages']),
    ...mapGetters(['todaysDate']),
    // The router already lets a TaxRead-only user reach this page (TaxRollAdjustment.js gates on
    // TaxRead OR AjustmentAuth), so creating a new adjustment here needs its own gate, same as
    // the Adjustment tab on Tax Inquiry.
    ...mapGetters('auth/token', ['isAjustmentAccessible']),
    ...mapState({
      lockedValues: (state) => state.tax.taxRollAdjustments.lockedValues,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      isDialogVisible: (state) => state.base.crud.isVisible.taxRollAdjustmentsList,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
    }),
    defaultTaxYearFromTaxSetting() {
      return Number((this.taxSettingItem || {}).taxYear) || 0;
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    selectedItems() {
      return this.selectedItemsOfAllPages(this.baseCrudKey) || [];
    },
    lockedRightItems: {
      get() {
        return this.lockedValues;
      },
      set(value) {
        this.setLockedValues(value);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'taxYear',
          direction: 'desc',
        },
        {
          column: 'taxId',
          direction: 'desc',
        },

      ];
    },
    errorMsgTaxYearTaxIdFunc() {
      const errList = this.errorMsgTaxYearTaxId;
      const errorMsgList = [];
      if (errList.length) {
        errList.map((ft) => {
          errorMsgList.push(`Tax Year: ${ft.taxYear}, Tax ID: ${ft.taxId} | `);
          return '';
        });
      }
      return errorMsgList.join('');
    },
    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
  },
  watch: {
    // latestTaxYear(newVal) {
    //   // will rmeove this line in future
    //   // if (newVal && !oldVal) this.criteriaState.taxYear = 0;
    //   if (newVal !== 0) {
    //     this.isItFirstCallOrNot = true;
    //     this.handleLoadCRUDList();
    //   }
    // },
    defaultTaxYearFromTaxSetting(newVal) {
      if (newVal !== 0) {
        this.isItFirstCallOrNot = true;
        this.handleLoadCRUDList();
      }
    },
    isDialogVisible(val) {
      if (val) {
        this.enableSaveBtn = false;
        setTimeout(() => {
          this.enableSaveBtn = true;
        }, 100);
      }
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
      'setIsVisible',
      'setItem',
      'setSelectedItemsOfAllPages',
    ]),
    ...mapMutations('tax/taxRollAdjustments', [
      'setSelectedItems',
      'setLockedValues',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    ...mapActions('tax/taxRollAdjustments', [
      'loadTaxAdjustments',
      'upsertTaxRollAdjustments',
      'upsertCreateWorkFile',
      'markedPostedRecords',
      'adjustmentCertCheck',
      'bulkDeleteAdjustments',
    ]),
    ...mapActions(['custumColrFlashMsg']),
    async initCriteria() {
      this.criteriaState = {};
      this.criteriaState.taxYear = 0;
      this.criteriaState.fromDate = toShortDate();
      this.criteriaState.toDate = toShortDate();
      this.loadConfig({ requiredScope: 'taxConfig' });
      this.setSelectedItemsOfAllPages([this.baseCrudKey, []]);
    },
    handleAddOrEdit(item, addOrEdit) {
      this.activeTransItem = item;
      if (addOrEdit === 'newItem') {
        setTimeout(() => this.$refs.adjustmentDialog.handleNewRecordClick(), POST_LOAD_COMP_TIMER);
      } else {
        setTimeout(() => this.$refs.adjustmentDialog.handleEditRecordClick(), POST_LOAD_COMP_TIMER);
      }
    },
    crudDialogClose() {
      this.lockedRightItems = true;
      this.$refs.adjustmentDialog.disabledTaxYearId = false;
      this.$refs.adjustmentDialog.ownerInfo = {};
      this.$refs.adjustmentDialog.afterAdjustment = {};
      this.$refs.adjustmentDialog.totalLevies = 0;
      this.$refs.adjustmentDialog.grossAssessed = 0;
      this.$refs.adjustmentDialog.netAssessed = 0;
      this.$refs.adjustmentDialog.calculatedTaxAmount = 0;
    },
    async handleLoadCRUDList(criteriaArgs = {}) {
      this.lockedRightItems = true;
      if (this.isItFirstCallOrNot) {
        manageGridLoading(this, true, 'Searching...');
        const { baseCrudKey } = this;
        const schoolDistrict = this.criteriaState.taxDistrict || '';
        this.criteriaState.schoolDistrict = schoolDistrict;
        delete this.criteriaState.taxDistrict;
        const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
        this.criteriaState = { ...returnCriteria };
        const criteria = {
          ...this.criteriaState,
          ...{
            fromDate: this.criteriaState.fromDate ? toIsoDate(this.criteriaState.fromDate)
              : this.criteriaState.fromDate,
            toDate: this.criteriaState.toDate ? toIsoDate(this.criteriaState.toDate)
              : this.criteriaState.toDate,
          },
        };
        this.loadTaxAdjustments({
          criteria,
          baseCrudKey,
          criteriaArgs,
        }).finally(() => {
          manageGridLoading(this, false);
        });
      }
    },
    async upsrtTransaction() {
      if (this.isSaving) return;
      const validate = this.$refs.crudList.$refs.crudDialog.validateForm();
      if (!validate) return;

      this.isSaving = true;
      try {
        const { baseCrudKey } = this;
        const item = this.item(baseCrudKey);
        if (this.isValidFormProp(baseCrudKey).value && item.taxId && item.taxYear) {
          const objItem = { ...item };

          const { disabledPosted } = this.$refs.adjustmentDialog;
          if (disabledPosted) {
            delete objItem.posted;
          }
          objItem.adjDate = item.adjDate ? toIsoDate(item.adjDate) : null;
          objItem.filedDate = item.filedDate ? toIsoDate(item.filedDate) : null;
          objItem.certDate = item.certDate ? toIsoDate(item.certDate) : null;
          if (objItem.adjOrUpd === 'UPDATE') {
            delete objItem.landVal;
            delete objItem.improvementVal;
            delete objItem.mobileVal;
            delete objItem.penaltyVal;
            delete objItem.totalExemptions;
            delete objItem.taxAmt;
          } else {
            objItem.landVal = amountToNumber(objItem.landVal);
            objItem.improvementVal = amountToNumber(objItem.improvementVal);
            objItem.mobileVal = amountToNumber(objItem.mobileVal);
            objItem.penaltyVal = amountToNumber(objItem.penaltyVal);
            objItem.totalExemptions = amountToNumber(objItem.totalExemptions);
            objItem.taxAmt = amountToNumber(objItem.taxAmt);
          }
          const updatedItem = { ...objItem };
          updatedItem.taxYear = parseInt(updatedItem.taxYear, 10);
          updatedItem.taxId = parseInt(updatedItem.taxId, 10);
          updatedItem.certNumber = parseInt(updatedItem.certNumber, 10);
          // updatedItem.posted = updatedItem.posted === 'Y';
          const beforeAdjustment = this.$refs.adjustmentDialog.ownerInfo;
          updatedItem.valuesBeforeAdjustment = {
            name: beforeAdjustment.name,
            land: amountToNumber(beforeAdjustment.land),
            improvements: amountToNumber(beforeAdjustment.improvements),
            mobileHome: amountToNumber(beforeAdjustment.mobileHome),
            exemptions: amountToNumber(beforeAdjustment.exemptions),
            totalTax: amountToNumber(beforeAdjustment.totalTax),
            assessorPenalty: amountToNumber(beforeAdjustment.assessorPenalty),
            schoolDistrict: beforeAdjustment.schoolDistrict || '',
          };

          const { afterAdjustment } = this.$refs.adjustmentDialog;
          updatedItem.valuesAfterAdjustment = {
            land: amountToNumber(afterAdjustment.land),
            improvements: amountToNumber(afterAdjustment.improvements),
            mobileHome: amountToNumber(afterAdjustment.mobileHome),
            exemptions: amountToNumber(afterAdjustment.exemptions),
            totalTax: amountToNumber(afterAdjustment.totalTax),
            assessorPenalty: amountToNumber(afterAdjustment.assessorPenalty),
          };
          let resp = { status: false };
          if (!updatedItem._id) {
            resp = await this.adjustmentCertCheck({
              criteria:
         {
           taxYear: parseInt(updatedItem.taxYear, 10),
           taxId: parseInt(updatedItem.taxId, 10),
           certNumber: parseInt(updatedItem.certNumber, 10),
         },
            });
          }
          if (resp.status && !this.$refs.adjustmentDialog.continueSubmit && updatedItem.certNumber) {
            this.$refs.adjustmentDialog.dialogCert = true;
            this.$refs.adjustmentDialog.dialogeMessage = resp.message;
          } else {
            await this.upsertTaxRollAdjustments({
              item: updatedItem,
              baseCrudKey,
            });
            this.$nextTick(() => {
              this.$refs.adjustmentDialog.continueSubmit = false;
              this.setIsVisible([baseCrudKey, false]);
            });
          }
        }
      } finally {
        this.isSaving = false;
      }
    },
    async createWorkFile() {
      const { selectedItems } = this;
      const items = selectedItems.filter((el) => typeof el === 'object');
      if (items.length === 0) {
        return true;
      }

      const msg = `Are you sure want to add ${items.length} records on work file ?`;
      if (window.confirm(msg)) {
        const _ids = [];
        for (const value of items) {
          _ids.push(value._id);
        }

        const upsert = {
          _ids,
          wkstID: Number(this.wkstID),
        };

        const response = await this.upsertCreateWorkFile({ upsert });
        const criteria = {
          name: response.name,
        };
        // user TR Browse Base crud key for opend on created TR work file
        this.setCriteria(['browseListNames', criteria]);
        const route = '/tax/trworkfile/browse';
        this.$router.push(route);
        return response;
      }

      return {};
    },
    // async deleteAdjustment() {
    //   const { selectedItems } = this;
    //   const items = selectedItems.filter((el) => typeof el === 'object');
    //   const onlyUnposetdItems = items.filter((el) => !el.posted);
    //   console.info(onlyUnposetdItems);
    //   if (onlyUnposetdItems.length === 0) {
    //     this.custumColrFlashMsg({ msg: 'No unposted records selected for deletion!' });
    //     return true;
    //   }
    //   const msg = `Are you sure want to delete ${items.length} records ?`;
    //   if (window.confirm(msg)) {
    //     const _ids = [];
    //     for (const value of onlyUnposetdItems) {
    //       _ids.push(value._id);
    //     }
    //     const upsert = {
    //       _ids,
    //       // wkstID: Number(this.wkstID),
    //     };
    //     await this.bulkDeleteAdjustments({ upsert });

    //     this.handleLoadCRUDList();
    //     return true;
    //   }

    //   return {};
    // },
    async postSelectedRecords() {
      const toLocalDateOnly = (dateValue) => {
        const parsedDate = parseLocalDate(dateValue);
        if (!parsedDate || Number.isNaN(parsedDate.getTime())) {
          return null;
        }
        return parsedDate;
      };

      const postingFromDate = toLocalDateOnly(this.taxSettingItem.curPostPerFromDate);
      const postingToDate = toLocalDateOnly(this.taxSettingItem.curPostPerToDate);

      this.disablePostAdjBtn = false;
      const { selectedItems } = this;
      let items = selectedItems.filter((el) => typeof el === 'object');
      if (items.length === 0) {
        return true;
      }
      items = selectedItems.filter((el) => el.posted !== 'Y');
      // check for records are in posting period date range
      let notInsidePostingDate = false;
      let notInPostingDate = '';
      // eslint-disable-next-line array-callback-return
      items.map((el) => {
        const adjDate = toLocalDateOnly(el.adjDate);
        if (adjDate && (adjDate < postingFromDate || adjDate > postingToDate)) {
          notInsidePostingDate = true;
          notInPostingDate = toShortDate(adjDate);
        }
      });
      if (!items.length) {
        this.custumColrFlashMsg({ msg: 'All selected records are already posted!' });
      } else if (!this.taxSettingItem.curPostPerFromDate || !this.taxSettingItem.curPostPerToDate) {
        this.allMessageText.push({
          txtName: 'errorRed',
          txtMsg: 'Posting period is required from Tax-setting',
        });
        this.disablePostAdjBtn = true;
        this.showAdjPopUp = true;
      } else if (notInsidePostingDate) {
        this.allMessageText.push({
          txtName: 'defaultText',
          txtMsg: `Adjustment can not be posted for ${notInPostingDate} 
          current posting Period is ${this.taxSettingItem.curPostPerFromDate} to  ${this.taxSettingItem.curPostPerToDate}`,
        });
        this.showErrorDialog = true;
      } else {
        for (const value of items) {
          const { adjDate, taxYear, taxId } = value;
          if (adjDate) {
            const check = toLocalDateOnly(adjDate);

            // we require below validation and when its not posted we dont need to validate
            if (check && postingFromDate && postingToDate
              && check >= postingFromDate && check <= postingToDate) {
              this.adjSelectedIds.push(value._id);
            } else this.errorMsgTaxYearTaxId.push({ taxYear, taxId });
          }
        }
        if (this.errorMsgTaxYearTaxId.length) {
          this.allMessageText.push({
            txtName: 'errorRed',
            txtMsg: 'The above mentioned records needs to be within the posting period',
          });
          this.showAdjPopUp = true;
          this.disablePostAdjBtn = true;
        } else {
          this.allMessageText.push({
            txtName: 'defaultText',
            txtMsg: `Are you sure want to post ${this.adjSelectedIds.length} records ?`,
          });
          this.showAdjPopUp = true;
        }
      }
      return {};
    },
    async openConfirmPopUpAdj(fromWhere) {
      if (fromWhere === 'continue') {
        this.showAdjPopUp = false;
        this.allMessageText = [];
        this.errorMsgTaxYearTaxId = [];
        if ((this.adjSelectedIds || []).length) {
          const _ids = [...this.adjSelectedIds];
          const upsert = { _ids };
          await this.markedPostedRecords({ upsert });
          this.handleLoadCRUDList();
          this.adjSelectedIds = [];
          this.disablePostAdjBtn = false;
        }
      } else if (fromWhere === 'Cancel') {
        this.showAdjPopUp = false;
        this.adjSelectedIds = [];
        this.disablePostAdjBtn = false;
        this.errorMsgTaxYearTaxId = [];
        this.allMessageText = [];
      }
    },
    handleCircleClass(textName) {
      if (textName === 'errorRed') return 'ChangeIconRedColor';
      if (textName === 'defaultText') return 'removeIcon';
      return 'ChangeIconYellowColor';
    },

    closeErrorDialog() {
      this.showErrorDialog = false;
      // Clear the error message for the posting period error
      this.allMessageText = this.allMessageText.filter((msg) => msg.txtName !== 'defaultText');
    },
    updateValuesReversingAdjustment(key, adjustments, values) {
      let returnValues = {};
      if (key === 'valuesBeforeAdjustment') {
        returnValues = {
          assessorPenalty: amountFormat(values.assessorPenalty + (adjustments.assessorPenalty)),
          exemptions: amountFormat(values.exemptions + (adjustments.exemptions)),
          improvements: amountFormat(values.assessorPenalty + (adjustments.assessorPenalty)),
          land: amountFormat(values.improvements + (adjustments.improvements)),
          mobileHome: amountFormat(values.mobileHome + (adjustments.mobileHome)),
          totalTax: amountFormat(values.totalTax + (adjustments.totalTax)),
          name: values.name,
          schoolDistrict: values.schoolDistrict,
        };
      } else if (key === 'valuesAfterAdjustment') {
        returnValues = {
          assessorPenalty: amountFormat(values.assessorPenalty - (adjustments.assessorPenalty)),
          exemptions: amountFormat(values.exemptions - (adjustments.exemptions)),
          improvements: amountFormat(values.assessorPenalty - (adjustments.assessorPenalty)),
          land: amountFormat(values.improvements - (adjustments.improvements)),
          mobileHome: amountFormat(values.mobileHome - (adjustments.mobileHome)),
          totalTax: amountFormat(values.totalTax - (adjustments.totalTax)),
        };
      }
      return returnValues;
    },
    // async createReversingEntry() {
    //   delete this.editedItem.posted;
    //   delete this.editedItem._id;
    //   this.lockedRightItems = false;
    //   const {
    //     improvementVal, landVal, mobileVal, penaltyVal, totalExemptions, taxAmt,
    //     valuesBeforeAdjustment, valuesAfterAdjustment, taxYear, schoolDistrict,
    //     adjDate, certDate,
    //   } = this.editedItem;
    //   // change the values before adjustment and values after adjustment
    //   const valuesAdjusted = {
    //     land: landVal,
    //     improvements: improvementVal,
    //     mobileHome: mobileVal,
    //     exemptions: totalExemptions,
    //     totalTax: taxAmt,
    //     assessorPenalty: penaltyVal,
    //   };
    //   // reverse the adjustment also
    //   this.editedItem.taxYear = taxYear;
    //   this.editedItem.improvementVal = -(this.editedItem.improvementVal);
    //   this.editedItem.landVal = -(this.editedItem.landVal);
    //   this.editedItem.mobileVal = -(this.editedItem.mobileVal);
    //   this.editedItem.penaltyVal = -(this.editedItem.penaltyVal);
    //   this.editedItem.totalExemptions = -(this.editedItem.totalExemptions);
    //   this.editedItem.taxAmt = -(this.editedItem.taxAmt);

    //   const afterAdjustment = this.updateValuesReversingAdjustment('valuesAfterAdjustment',
    //  valuesAdjusted, valuesAfterAdjustment);
    //   this.$refs.adjustmentDialog.afterAdjustment = { ...afterAdjustment };
    //   const ownerInfo = this.updateValuesReversingAdjustment('valuesBeforeAdjustment',
    //  valuesAdjusted, valuesBeforeAdjustment);
    //   this.$refs.adjustmentDialog.ownerInfo = { ...ownerInfo };
    //   const {
    //     land, improvements, mobileHome, exemptions, totalTax,
    //   } = afterAdjustment;
    //   // eslint-disable-next-line max-len
    //   this.$refs.adjustmentDialog.handleCalculatedTax(land, improvements, mobileHome,
    //  exemptions, totalTax, schoolDistrict);
    //   this.$refs.adjustmentDialog.trigerInfoForceFully(taxYear, adjDate, certDate);
    // },
    async createReversingEntry() {
      const selectedItem = this.editedItem;
      if (selectedItem.taxYear && selectedItem.taxId) {
        this.setIsVisible([this.baseCrudKey, true]);
        delete selectedItem.posted;
        delete selectedItem._id;
        this.lockedRightItems = false;
        const {
          improvementVal, landVal, mobileVal, penaltyVal, totalExemptions, taxAmt,
          valuesBeforeAdjustment, valuesAfterAdjustment, schoolDistrict,
          adjDate, certDate,
        } = selectedItem;

        // change the values before adjustment and values after adjustment
        const valuesAdjusted = {
          land: landVal,
          improvements: improvementVal,
          mobileHome: mobileVal,
          exemptions: totalExemptions,
          totalTax: taxAmt,
          assessorPenalty: penaltyVal,
        };
        // reverse the adjustment also
        selectedItem.improvementVal = -(improvementVal);
        selectedItem.landVal = -(landVal);
        selectedItem.mobileVal = -(mobileVal);
        selectedItem.penaltyVal = -(penaltyVal);
        selectedItem.totalExemptions = -(totalExemptions);
        selectedItem.taxAmt = -(taxAmt);
        selectedItem.adjDate = adjDate ? toShortDate(adjDate) : adjDate;
        selectedItem.certDate = certDate ? toShortDate(certDate) : certDate;

        this.newItemDialog(selectedItem); // updating new data

        setTimeout(() => {
          // updating the local component store for clarion date
          this.$refs.adjustmentDialog.intDate.adjDate = adjDate ? toShortDate(adjDate) : adjDate;
          this.$refs.adjustmentDialog.intDate.certDate = certDate
            ? toShortDate(certDate) : certDate;
          // this is required we need to give some delay for dialog-component to be loaded
          const afterAdjustment = this.updateValuesReversingAdjustment('valuesAfterAdjustment', valuesAdjusted, valuesAfterAdjustment);
          this.$refs.adjustmentDialog.afterAdjustment = { ...afterAdjustment };
          const ownerInfo = this.updateValuesReversingAdjustment('valuesBeforeAdjustment', valuesAdjusted, valuesBeforeAdjustment);
          this.$refs.adjustmentDialog.ownerInfo = { ...ownerInfo };
          const {
            land, improvements, mobileHome, exemptions, totalTax, assessorPenalty,
          } = afterAdjustment;

          this.$refs.adjustmentDialog.handleCalculatedTax({
            land,
            improvements,
            mobileHome,
            exemptions,
            totalTax,
            schoolDistrict,
            penalty: amountToNumber(assessorPenalty),
          });
          // this.$refs.adjustmentDialog.trigerInfoForceFully(taxYear, adjDate, certDate);
        }, POST_LOAD_COMP_TIMER);
      }
    },
    newItemDialog(item) {
      // this.setIsValidFormProp([this.baseCrudKey, true]);
      // setTimeout(() => {
      let newItem = {
        adjOrUpd: 'ADJUST',
        taxYear: this.criteriaState.taxYear || this.defaultTaxYearFromTaxSetting
        || this.latestTaxYear,
        // taxId: null,
        // type: '',
      };
        // newItem = { ...item };
      if (item && item.taxYear && item.taxId) newItem = { ...item };
      // console.info('newItem', newItem);
      return newItem;
      // }, 2000);
    },
  },
};
</script>

<style scoped>
.error-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 20px;
}

.error-title {
  margin-bottom: 12px;
  color: #333333;
  text-align: center;
  font-size: 18px;
}

.error-message {
  width: 100%;
  margin-bottom: 12px;
}

.text-center {
  text-align: center;
  white-space: pre-wrap;
  line-height: 1.5;

}

.single-button-container {
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
